import { TenantInfoResponse } from "../types/livechat.types";
import agentPlatformClient from "./agent-platform-client";

export const getTenantInfo = (agencyId: string, staffId?: string) => {
  const params = new URLSearchParams({ agencyId });
  if (staffId) params.append("staffId", staffId);
  return agentPlatformClient.get<any, TenantInfoResponse>(
    `/api/v1/tenants/tenantInfo?${params.toString()}`
  );
};
